import React from 'react';

import styled from 'styled-components';

import { Flex } from '@adsk/alloy-react-box';
import { MalwareIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../i18n';
import TooltipWithLearnMore from './TooltipWithLearnMore';

const StyledFlex = styled(Flex).attrs({
  alignItems: 'center',
})`
  cursor: default;
`;

const StyledMalwareIcon = styled(MalwareIcon)`
  margin-left: 8px;
  flex-shrink: 0;
  vertical-align: middle;
  color: ${theme.colors.red600};
  &:hover {
    color: ${theme.colors.red600};
  }
`;

const iconTargetProps = () => ({
  style: { display: 'inline-flex', alignItems: 'center' },
});

const MalwareContent = ({ children, style }) => {
  const { t } = useTranslation();

  return (
    <StyledFlex style={style}>
      {children}
      <TooltipWithLearnMore
        content={t('MALWARE_TIP')}
        onClickLearnMore={() =>
          window.open(t('MALWARE_HELP_URL'), '_blank', 'noopener,noreferrer')
        }
        getTargetProps={iconTargetProps}
      >
        <StyledMalwareIcon size={16} />
      </TooltipWithLearnMore>
    </StyledFlex>
  );
};

export default MalwareContent;
